// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"647":"f696ddb2","696":"a4542e54"}[chunkId] + ".css";
};